export const environment = {
  production: true,
  authApiUrl:
    'https://v5rh7ba4qi.execute-api.eu-west-1.amazonaws.com/pre/api/v1',
  apiUrl: 'https://hmmz07pm8i.execute-api.eu-west-1.amazonaws.com/pre/api/v1',
  akerChatApiUrl: 'https://api.wearevx.ai/api/v1',
  akerChatChannelId: 1,
  akerChatChannelToken: '3lMlk9odTBkCwXX6',
  akerOpencodeApiUrl:
    'https://ibu6xeb367xuyuel4b4p2rhsce0zetho.lambda-url.us-east-1.on.aws',
  akerOpencodeRequestTimeoutMs: 840000,
  bedrockAgentEnabled: true,
  bedrockAgentApiUrl:
    'https://ibu6xeb367xuyuel4b4p2rhsce0zetho.lambda-url.us-east-1.on.aws'
}
